import {
  Box,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, Icon, stitchGradientBtn, stitchOutlineBtn } from '../parts/stitch';
import CallsheetCard from '../parts/CallsheetCard';
import DuplicateCallsheetDialog from '../../CallSheet/DuplicateCallsheetDialog';
import { useProjectData } from '../ProjectDataContext';

function CallsheetsPanel() {
  const navigate = useNavigate();
  const {
    id,
    callsheets,
  } = useProjectData();
  const [duplicateTarget, setDuplicateTarget] = useState(null);

  return (
    <>
        {callsheets.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Icon name="phone" size={48} sx={{ color: T.outlineVariant, display: 'block', mx: 'auto', mb: 1 }} />
            <Typography sx={{ fontFamily: T.fontBody, color: T.outline, mb: 2 }}>Geen callsheets gevonden</Typography>
            <Box
              component="span"
              onClick={() => navigate(`/callsheets?project=${id}&new=1`)}
              sx={stitchGradientBtn}
            >
              <Icon name="playlist_add" size={18} />
              Nieuwe Callsheet
            </Box>
          </Box>
        ) : (
          <>
          {/* Header with action button - only when there are callsheets */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Box
              component="span"
              onClick={() => navigate(`/callsheets?project=${id}&new=1`)}
              sx={stitchGradientBtn}
            >
              <Icon name="playlist_add" size={18} />
              Nieuwe Callsheet
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {callsheets.map((cs) => (
              <Box key={cs.id} sx={{ position: 'relative' }}>
                <Box onClick={() => navigate(`/callsheets/${cs.id}`)} sx={{ cursor: 'pointer' }}>
                  <CallsheetCard callsheet={cs} />
                </Box>
                <Box
                  component="span"
                  onClick={(e) => { e.stopPropagation(); setDuplicateTarget(cs); }}
                  sx={{ ...stitchOutlineBtn, py: 0.4, fontSize: '0.75rem',
                    position: 'absolute', top: 12, right: 12 }}
                >
                  <Icon name="content_copy" size={14} />
                  Dupliceren
                </Box>
              </Box>
            ))}
          </Box>
          </>
        )}
        <DuplicateCallsheetDialog callsheet={duplicateTarget} onClose={() => setDuplicateTarget(null)} />
    </>
  );
}

export default CallsheetsPanel;
